import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import { enableES5 } from 'immer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/context/SettingsContext';
import { configureStore } from 'src/store';
import { restoreSettings } from 'src/utils/settings';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import App from 'src/App';

enableES5();

const store = configureStore();
const settings = restoreSettings();
/*Para acceder al store: $r.props.store.getState()*/
/*Test Branch*/
ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <SettingsProvider settings={settings}>
        <App />
      </SettingsProvider>
    </I18nextProvider>
  </Provider>
  ,
  document.getElementById('root')
);

serviceWorker.unregister();
